<template>
  <combobox
    ref="primaryInput"
    class="product-combobox"
    :options="options"
    :label="label"
    :placeholder="placeholder"
    :value="internalValue"
    :errors="internalErrors"
    :disabled="disabled"
    :is-loading="isLoading"
    :internal-search="false"
    @input="onInput"
    @search="onSearch"
    @close="onClose"
  >
    <template slot="option" scope="props">
      <div class="product-combobox__name">
        <span v-if="useVariantName">
          {{props.option.variantName || props.option.name}}
        </span>
        <span v-else>{{props.option.name}}</span>
      </div>
      <div class="product-combobox__article-number">
        {{props.option.articleNumber}}
      </div>
    </template>
  </combobox>
</template>

<script>
import productsWithoutAttachmentsQuery
  from '@/api/queries/products-without-attachments.graphql';
import ResourceCombobox from '@/mixins/ResourceCombobox';

export default {
  name: 'product-combobox',
  mixins: [
    ResourceCombobox({
      searchQuery: productsWithoutAttachmentsQuery,
      unfilteredSort: { field: 'UPDATED_AT', direction: 'DESC' },
    }),
  ],
  props: {
    useVariantName: Boolean,
  },
};
</script>

<style lang="scss">
.product-combobox__article-number {
  opacity: 0.6;
}
</style>



// WEBPACK FOOTER //
// ProductCombobox.vue?3687291a